// GAMES
export const FETCH_GAMES_REQUEST = 'FETCH_GAMES_REQUEST';
export const FETCH_GAMES_SUCCESS = 'FETCH_GAMES_SUCCESS';

// ROUTER
export const CHANGE_ROUTE = 'CHANGE_ROUTE';

// GAME
export const FETCH_GAME_SCREENSHOTS_SUCCESS = 'FETCH_GAME_SCREENSHOTS_SUCCESS';

// APP
export const PLAY_FULL_VIDEO = 'PLAY_FULL_VIDEO';
export const CLOSE_FULL_VIDEO = 'CLOSE_FULL_VIDEO';
export const WINDOW_RESIZE = 'WINDOW_RESIZE';

// USER
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const CLEAR_USER = 'CLEAR_USER';
export const UPDATE_USER_USERNAME = 'UPDATE_USER_USERNAME';
export const FETCH_USER_LIKES_SUCCESS = 'FETCH_USER_LIKES_SUCCESS';
export const TOGGLE_LIKE = 'TOGGLE_LIKE';

// USER PROFILE
export const FETCH_VISITED_USER_REQUEST = 'FETCH_VISITED_USER_REQUEST';
export const FETCH_VISITED_USER_SUCCESS = 'FETCH_VISITED_USER_SUCCESS';

// USER SETTINGS
export const UPDATE_USER_PROFILE_SUCCESS = 'UPDATE_USER_PROFILE_SUCCESS';
